/**
 * MypagePointContainer
 * --
 */
import React from 'react';
import MypagePointPresenter from './MypagePointPresenter';
import { useUserStack } from 'store';
import { useMyPoint } from 'hooks/custom';
import dayjs from 'dayjs';
import { useGetPointHistoryLogs } from 'hooks/PointHistoryLogHooks';

const MypagePointContainer = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { screenSize } = props;
  /* ===== VARIABLE ===== */

  /* ===== Store ===== */
  const userInfo = useUserStack();

  /* ===== STATE ===== */
  // Period Date
  const [selected, setSelected] = React.useState([1, 'month']);
  // loading
  const [isLoading, setIsLoading] = React.useState(false);

  /* ===== Data ===== */
  const MyPoint = useMyPoint(userInfo.user_id);
  const { data: PointHistory } = useGetPointHistoryLogs(
    {
      user_id: userInfo.user_id,
      start_date: dayjs().subtract(selected[0], selected[1]).unix(),
    },
    {
      enabled: !!userInfo,
      select: (res) => {
        if (res.status !== 200) return [];

        return res.data;
      },
      initialData: [],
    }
  );

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /**
   * 포인트 적립내역
   * --
   */
  const MyPointHistory = React.useMemo(() => {
    if (!PointHistory?.length) return [];

    return PointHistory;
  }, [PointHistory]);

  /**
   * 사용가능 포인트, 소멸예정 포인트
   */

  /* ===== RENDER ===== */
  return (
    <>
      <MypagePointPresenter
        history={MyPointHistory}
        selected={selected}
        onSelect={setSelected}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        point={MyPoint}
        screenSize={screenSize}
      />
    </>
  );
};

export default MypagePointContainer;
